var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 69,
    viewBox: "0 0 52 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 29.25C4.36475 29.25 0 33.6147 0 39V58.5C0 63.8853 4.36475 68.25 9.75 68.25H42.25C47.6353 68.25 52 63.8853 52 58.5V39C52 33.6147 47.6353 29.25 42.25 29.25C42.25 29.25 42.25 21.346 42.25 16.25C42.25 7.27675 34.9733 0 26 0C17.0268 0 9.75 7.27675 9.75 16.25V29.25ZM26 45.5C27.794 45.5 29.25 46.956 29.25 48.75C29.25 50.544 27.794 52 26 52C24.206 52 22.75 50.544 22.75 48.75C22.75 46.956 24.206 45.5 26 45.5ZM35.75 29.25V16.25C35.75 10.8647 31.3853 6.5 26 6.5C20.6147 6.5 16.25 10.8647 16.25 16.25V29.25H35.75Z",
    fill: "url(#paint0_linear_949_167)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_949_167",
    x1: 56.0701,
    y1: -6.69743,
    x2: 4.21994,
    y2: 68.4515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#030AC0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.1a76e7af542484ab4f63f4f6d2811ef6.svg";
export { ForwardRef as ReactComponent };